import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Close extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <polygon points="22,4.1 19.9,2 12,9.8 4.2,2 2,4.1 9.9,12 2,19.8 4.2,22 12,14.1 19.9,22 22,19.8 14.2,12 " />
            </SvgIcon>
        );
    }
}

export default Close;
